import { render, staticRenderFns } from "./ProjectUpdates.vue?vue&type=template&id=293a9c0d"
import script from "./ProjectUpdates.vue?vue&type=script&lang=js"
export * from "./ProjectUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports